/*@flow*/
import { defaultPopUpOptions } from 'lib/folio/decks/Popup';
import ProjectPopup from 'comps/ProjectPopup';

type PropsT = { id?: ID, latlon: ?Array<number> };

export default function showOnMap({ id, latlon }: PropsT) {
  const map = window.cityMap || window.districtMap;
  if (!latlon) return;
  if (!map) return;

  const [lat, lon] = latlon;
  // Open a popup at latlon with project id and latlon
  const opts = {
    component: ProjectPopup,
    id,
    lonlat: [lon, lat],
    ...defaultPopUpOptions,
  };
  const markup = "<div class='pop-component'></div>";
  map.openPopup(markup, latlon, opts);
}
